import classNames from 'classnames';

import { useEffect, useState } from 'react';

function NumberInputReadonly({ value, className }: { value: number; className?: string }) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div
      className={classNames(
        'py-xs',
        'w-fit',
        'flex flex-row items-center justify-start',
        className
      )}
    >
      {inputValue || ''}
    </div>
  );
}

export default NumberInputReadonly;
